var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-layout"},[_c('div',{staticClass:"split-column"},[_vm._t("default")],2),(_vm.displaySecondColumn)?_c('div',{staticClass:"split-column"},[_c(_vm.dynamicComponent,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }